import App from '@/App.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import store from '@/store/store'
import VueKatex from 'vue-katex'
import VueScrollTo from 'vue-scrollto'
import 'katex/dist/katex.min.css'

// UIコンポーネントの読み込み
import vuetify from './plugins/vuetify'

// pluginの読み込み
import router from '@/router'
import '@/plugins/vee-validate'

// cognitoの読み込み
import cognito from './cognito'

Vue.config.productionTip = false

Vue.use(Vuex)
Vue.use(VueKatex)
Vue.use(VueScrollTo, {
  offset: -75
})

new Vue({
  vuetify,
  router,
  cognito,
  store,
  render: (h) => h(App)
}).$mount('#app')
